import React, { useEffect, useState, Fragment } from 'react';
import { Accordion, Spinner, Alert } from 'react-bootstrap';
import PrayerItem from './prayer';
import { db } from '../services/firebase';

const List = ({ mosquee, admin }) => {
    const [loading, setLoading] = useState(true);
    const [prayers, setPrayers] = useState([]);
    const [confirmMessage, setConfirmMessage] = useState(null);
    
    useEffect(() => {
        db.collection(mosquee).get().then(snapshot => {
            let newPrayers = []
            snapshot.forEach((snap) => {
                let newPrayer = snap.data();
                newPrayer.id = snap.id;
                newPrayers.push(newPrayer);
                setPrayers(newPrayers);
            })
            setLoading(false);
        })
    }, [])

    const handleConfirmation = () => {
        setConfirmMessage("Votre réservation a bien été enregistrée.")
    }

    return(
        <Fragment> 
            {confirmMessage ? <Alert variant="success">
                {confirmMessage}
            </Alert> : null}
            <div className="d-flex align-items-center justify-content-center w-100">
                {loading 
                    ? <Spinner animation="border" variant="dark" />
                    :
                    <Accordion defaultActiveKey="0" className="w-100">
                        {[...Array(prayers.length).keys()].map(id => 
                            <PrayerItem id={id} key={id} data={prayers[id]} admin={admin} confirmationCallback={handleConfirmation} />
                        )}
                    </Accordion>
                }    
            </div>
        </Fragment>
    );
}

export default List;